// import { computed, defineComponent, toRefs } from 'vue'
import { defineComponent, toRefs } from 'vue'
import classes from '@/assets/styles/my-table.module.less'
import { DoubleLeftOutlined, DoubleRightOutlined } from '@ant-design/icons-vue'
import { setCollapseColumns } from '@/utils/store-table-size'

export default defineComponent({
  components: {
    DoubleLeftOutlined,
    DoubleRightOutlined
  },
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    columnsWidth: {
      type: Object,
      default: () => { }
    },
    collapseColumns: {
      type: Array,
      default: () => ([])
    },
    tableId: {
      type: String,
      default: ''
    }
  },
  setup (props, { emit }) {
    const { columns, columnsWidth, collapseColumns } = toRefs(props)
    function foldHandler (index) {
      if (!collapseColumns.value.includes(index)) {
        collapseColumns.value.push(index)
        setCollapseColumns(props.tableId, JSON.stringify(collapseColumns.value))
      }
    }

    function unfoldHandler (index) {
      if (collapseColumns.value.includes(index)) {
        collapseColumns.value.splice(collapseColumns.value.indexOf(index), 1)
        setCollapseColumns(props.tableId, JSON.stringify(collapseColumns.value))
      }
    }

    const generateHeaderItems = (cols) => {
      return cols.reduce((pre, cur) => {
        pre.push(
          'children' in cur && cur.children.length
            ? <div>
                <div className={classes.item}>
                  <div className={classes.content}>
                    {cur.title}
                  </div>
                </div>
                <div className={classes['header-grid']}>
                  {generateHeaderItems(cur.children)}
               </div>
              </div>
            : (
                collapseColumns.value.includes(cur.dataIndex)
                  ? (
                      <div className={classes.item} rightIndex={cur.dataIndex}>
                        <div className={classes.content} style={{ width: '34px' }}></div>
                        <div className={classes.collapse} onClick={ () => unfoldHandler(cur.dataIndex)}>
                            <DoubleRightOutlined/>
                        </div>
                      </div>
                    )
                  : (
                      <div className={classes.item} rightIndex={ cur.dataIndex }>
                        <div className={classes.content} style={{ width: `${columnsWidth.value[cur.dataIndex] - 1}px` }}>
                          {cur.title}
                        </div>
                        <div className={classes.right}></div>
                        <div className={classes.collapse} onClick={ () => foldHandler(cur.dataIndex)}>
                          <DoubleLeftOutlined/>
                        </div>
                      </div>
                    )
              )
        )
        return pre
      }, [])
    }
    return () => generateHeaderItems(columns.value)
  }
})
